import { render, staticRenderFns } from "./PollDisplaySettings.vue?vue&type=template&id=1c871d53&scoped=true"
import script from "./PollDisplaySettings.vue?vue&type=script&lang=js"
export * from "./PollDisplaySettings.vue?vue&type=script&lang=js"
import style0 from "./PollDisplaySettings.vue?vue&type=style&index=0&id=1c871d53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c871d53",
  null
  
)

export default component.exports